import {
  CURRENCY_SYMBOL } from
'@shootsta/common-domain-data';
import { getPriceVersion } from '../../AddonManagementModal/utils';


const getBillingRegionPrice = (
region,
voiceOverPricePosition,
priceVersion) =>
{
  const VOICE_OVER_PRICES = getPriceVersion(priceVersion);

  const [billingRegionAllPrices] = VOICE_OVER_PRICES.filter(
    (price) => price.billingEntityCode === region
  );

  return `${CURRENCY_SYMBOL[region]} ${billingRegionAllPrices.prices[voiceOverPricePosition]}`;
};

export default getBillingRegionPrice;